import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import CloudIcon from "@mui/icons-material/Cloud";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import moment from "moment";
import "moment/min/locales";
import { useTranslation } from "react-i18next";
moment.locale("ar");

export default function Card({ temp }) {
  const [dateAndTime, setDateAndTime] = useState();
  const { t, i18n } = useTranslation();
  const [locale, setLocale] = useState("ar");
  useEffect(() => {
    setDateAndTime(moment().format("MMMM Do YYYY, h:mm:ss a"));
    i18n.changeLanguage("ar");
  }, []);
  let direction = locale == "ar" ? "rtl" : "ltr";

  function translate() {
    if (locale == "en") {
      setLocale("ar");
      i18n.changeLanguage("ar");
      moment.locale("ar");
    } else {
      setLocale("en");
      i18n.changeLanguage("en");
      moment.locale("en");
    }
    setDateAndTime(moment().format("MMMM Do YYYY, h:mm:ss a"));
  }
  return (
    <>
      <Container maxWidth="sm">
        <div
          dir={direction}
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "90%",
              borderRadius: "15px",
              padding: "30px",
              color: "white",
              background: "rgb(28 52 91/36%)",
              boxShadow: "0px 11px 1px rgba(0,0,0,0.05)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "end",
                justifyContent: "start",
              }}
            >
              <Typography variant="h2">{t("Gaza")}</Typography>
              <Typography variant="h5" style={{ margin: "10px" }}>
                {dateAndTime}
              </Typography>
            </div>
            <hr />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h1">{temp.number}</Typography>
                  <img src={temp.icon} alt="" />
                </div>
                <Typography variant="h6">{t(temp.description)}</Typography>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <h5>
                    {t("min")}: {temp.min}
                  </h5>
                  <h5 style={{ margin: "0px 10px" }}>|</h5>
                  <h5>
                    {t("max")}: {temp.max}
                  </h5>
                </div>
              </div>
              <CloudIcon style={{ color: "white", fontSize: "200px" }} />
            </div>
          </div>
          <div
            style={{
              width: "100%",
              marginTop: "5px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="text"
              style={{ color: "white" }}
              dir="direction"
              onClick={translate}
            >
              {locale == "en" ? "Arabic" : "انجليزي"}
            </Button>
          </div>
        </div>
      </Container>
    </>
  );
}
